// Fixed rather than derived from `Date.now()` so fixture-backed tests stay deterministic. PLA-8815.
export const FIXTURE_UPDATED_AT = '2026-08-07T09:12:00Z';
